import React from 'react'

import { useNavigate } from 'react-router-dom'

import { AuthContext } from '../context/AuthContext'

import { axios } from '../services/axios'

import { formatError } from '../helpers/errors'

import type {
  SignInCredentials,
  UseAuthReturn,
} from '../helpers/types/hooks/auth.types'

export function useAuth(): UseAuthReturn {
  const navigate = useNavigate()

  const auth = React.useContext(AuthContext)

  async function signIn(credentials: SignInCredentials): Promise<void> {
    try {
      const { data: token } = await axios().post('auth', credentials)

      auth.setToken(token.access_token)

      navigate('/home', { replace: true })
    } catch (err) {
      throw formatError(err as Error)
    }
  }

  function signOut(): void {
    auth.destroyToken()

    navigate('/', { replace: true })
  }

  return {
    signIn,
    signOut,
    token: auth.token,
    user: auth.user,
  }
}
